var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7075 9.45747L7.71211 13.4528C7.52402 13.6409 7.26892 13.7466 7.00293 13.7466C6.73694 13.7466 6.48184 13.6409 6.29375 13.4528C6.10567 13.2648 6 13.0097 6 12.7437C6 12.4777 6.10567 12.2226 6.29375 12.0345L9.58993 8.7483L6.29375 5.46211C6.10567 5.27402 6 5.01892 6 4.75293C6 4.62122 6.02594 4.49081 6.07634 4.36912C6.12674 4.24744 6.20062 4.13688 6.29375 4.04375C6.38688 3.95062 6.49744 3.87675 6.61912 3.82634C6.7408 3.77594 6.87122 3.75 7.00293 3.75C7.26892 3.75 7.52402 3.85567 7.71211 4.04375L11.7075 8.03912C11.8011 8.13197 11.8754 8.24245 11.9261 8.36417C11.9768 8.48588 12.0029 8.61644 12.0029 8.7483C12.0029 8.88016 11.9768 9.01071 11.9261 9.13243C11.8754 9.25415 11.8011 9.36462 11.7075 9.45747V9.45747Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.8a045e4faa166d90987f088b2ef286cc.svg";
export { ForwardRef as ReactComponent };